import { useEffect, useState, useCallback } from 'react';
import { useLazyGetCallWithURL } from 'common/api/useApiCall';
import { URLS } from 'constants/URL';
import { TenantType } from 'customers/tenants-common-view/lib/schema/Tenant.types';

type useFeatureFlagsProps = {
  tenant: TenantType;
};

export const useFeatureFlags = (props: useFeatureFlagsProps) => {
  const { tenant } = props;
  const { _id, pgSource } = tenant;
  const [featureFlags, setFeatureFlags] = useState([]);

  const {
    response: featureFlagsResp,
    postData,
    isLoading,
  } = useLazyGetCallWithURL();

  useEffect(() => {
    if (!_id) {
      return;
    }
    // Build the URL with query parameters matching the curl command
    const baseUrl = URLS.getFeatureFlags;
    const params = new URLSearchParams({
      'page-size': '100',
      'page-offset': '0',
      'tenant-id': _id,
      'tenant-domain': pgSource || '',
    });
    const url = `${baseUrl}${params.toString()}`;
    postData(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, pgSource]);

  useEffect(() => {
    if (featureFlagsResp) {
      if (Array.isArray(featureFlagsResp.response)) {
        setFeatureFlags(featureFlagsResp.response);
      } else if (Array.isArray(featureFlagsResp)) {
        // Handle case where response is directly an array
        setFeatureFlags(featureFlagsResp);
      } else {
        setFeatureFlags([]);
      }
    }
  }, [featureFlagsResp]);

  const refreshFeatureFlags = useCallback(() => {
    if (!_id) {
      return;
    }
    const baseUrl = URLS.getFeatureFlags;
    const params = new URLSearchParams({
      'page-size': '100',
      'page-offset': '0',
      'tenant-id': _id,
      'tenant-domain': pgSource || '',
    });
    const url = `${baseUrl}${params.toString()}`;
    postData(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, pgSource]);

  return {
    featureFlags,
    isLoading,
    refreshFeatureFlags,
  };
};
